var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal-provider',{attrs:{"fullscreen-breakpoint":768,"name":"shop-card-modal","width":900},on:{"before-open":_vm.beforeOpen}},[_c('ShopCard',{attrs:{"is-adaptive":"","is-info-modal":"","shop-data":_vm.shopData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }